import { render, staticRenderFns } from "./BaseModalVisualizarExtratoConsultas.vue?vue&type=template&id=3b0e94bb&lang=pug"
import script from "./BaseModalVisualizarExtratoConsultas.vue?vue&type=script&lang=js"
export * from "./BaseModalVisualizarExtratoConsultas.vue?vue&type=script&lang=js"
import style0 from "./BaseModalVisualizarExtratoConsultas.vue?vue&type=style&index=0&id=3b0e94bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports